import styled from 'styled-components';

export const AdminPanel = styled.div`
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow-x: hidden;
  overflow-y: auto;
`;

AdminPanel.displayName = 'AdminPanel';
